import React, { useEffect, useState } from 'react';

// Hooks
import { useDispatch } from 'react-redux';

// Actions
import { fetchExportLogs } from '~/redux/actions/export-logs-actions';

// Utils
import { MESSAGES } from '~/utils/message';
import { DEFAULT_PAGINATION } from '~/utils/constants';

// Component
import ExportLogsTable from './ExportTable';

// MUI Components
import { Box, Typography } from '@mui/material';

// Styles
import './styles.scss';

const Export = () => {
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);

  const dispatch = useDispatch();

  useEffect(() => {
    let payload = {
      page: pagination?.page || DEFAULT_PAGINATION.page,
      pageSize: pagination?.pageSize || DEFAULT_PAGINATION.pageSize,
    };
    dispatch(fetchExportLogs(payload));
  }, [pagination.page, pagination.pageSize, dispatch]);

  return (
    <>
      <Box className="exportWrapper">
        <Box
          className="headerWrap"
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            '@media (max-width: 1199px)': {
              paddingTop: '20px',
            },
          }}
        >
          <Box className="ExportsRow">
            <Typography variant="h4">{MESSAGES.ACCOUNT.EXPORT_LOGS.TITLE}</Typography>
          </Box>
        </Box>
        <ExportLogsTable pagination={pagination} updatePagination={setPagination} />
      </Box>
    </>
  );
};

export default Export;
